import { useFormContext } from 'react-hook-form';
import { useMemo, useState } from 'react';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { Input, CustomInputProps } from '@dynamika-shared/ui/Input/Input';
import { TrashIcon } from '@dynamika-shared/ui/icons';

const inputProps: Partial<CustomInputProps> = {
  classNameLabel: 'mb-1 ',
  className: '!max-w-[20.6rem] flex !w-[20.6rem]',
};

export const MetadataFields = ({ index }: { index: number }) => {
  const { setValue, watch } = useFormContext();

  const metadata: Record<string, string> = watch(`actions.actions[${index}].metadata`);

  const [newKey, setNewKey] = useState('');
  const [newValue, setNewValue] = useState('');

  const metaData = useMemo(() => Object.entries(metadata || {}), [metadata]);

  const addMetadata = () => {
    if (!newKey.trim()) return;
    setValue(`actions.actions[${index}].metadata`, {
      ...metadata,
      [newKey]: newValue,
    });
    setNewKey('');
    setNewValue('');
  };

  const removeMetadata = (key: string) => {
    const updatedMetadata = { ...metadata };
    delete updatedMetadata[key];
    setValue(`actions.actions[${index}].metadata`, updatedMetadata);
  };
  return (
      <div className={'w-full flex justify-between items-start gap-3 flex-wrap'}>
        <div className={'grid gap-3 justify-between flex-grow grid-cols-[1fr_200px] w-full'}>
          <div className='grid grid-cols-[150px_1fr] gap-3 '>
            <Input
              {...inputProps}
              value={newKey}
              onChange={e => setNewKey(e.target.value)}
              placeholder='Key'
              classNameInputWrapper='!w-full !max-w-full'
              className='!w-full'
            />
            <Input
              {...inputProps}
              value={newValue}
              onChange={e => setNewValue(e.target.value)}
              placeholder='Value'
              classNameInputWrapper='!w-full !max-w-full'
              className='!w-full'
            />
          </div>

          <Button
            type={'text'}
            className={'text-1424 text-vividTangelo font-medium h-[48px] mt-1'}
            onClick={addMetadata}
          >
            + Add metadata
          </Button>
        </div>
        <div className={'flex flex-wrap items-center justify-start w-full'}>
          {metaData.map(([key, value]) => (
            <div className={'grid gap-3 justify-between flex-grow grid-cols-[1fr_30px] w-full items-center'} key={key}>
              <div className='grid grid-cols-[150px_1fr] gap-3'>
                <Input 
                  {...inputProps} 
                  disabled
                  value={key} 
                  disabledOpacity={10}
                  className='!w-full'
                />
                <Input
                  {...inputProps}
                  value={value}
                  disabled
                  disabledOpacity={10}
                  className='!w-full bg-brightGray'
                />
              </div>
              <TrashIcon
                className='cursor-pointer hover:text-redOrange min-w-3 z-10 -ms-1 me-3'
                width={24}
                height={24}
                onClick={() => removeMetadata(key)}
              />
            </div>
          ))}
        </div>
      </div>
  );
};
